export const getters = {
  athleteList: state => state.athleteList,
  athleteResults: state => state.athleteResults,
  athleteOfficialResults: state => state.athleteOfficialResults,
  resultsList: state => state.resultsList,
  allClubFormData: state => state.allClubFormData,
  allPersonCommunications: state => state.allPersonCommunications
};
